import React from "react";
import "./ClearableField.css";

const hasClearableValue = (value) => {
  if (value === null || value === undefined) {
    return false;
  }
  if (typeof value === "boolean") {
    return true;
  }
  return String(value).trim() !== "";
};

const ClearableField = ({
  value,
  onClear,
  disabled = false,
  children,
  className = "",
}) => {
  const showClear = hasClearableValue(value) && !disabled && onClear;

  return (
    <div className={`justo-clearable-field ${className}`.trim()}>
      {children}
      {showClear ? (
        <button
          type="button"
          className="justo-clearable-field__clear"
          onClick={onClear}
          aria-label="Clear"
          tabIndex={-1}
        >
          <i className="fa fa-times" aria-hidden="true" />
        </button>
      ) : null}
    </div>
  );
};

export default ClearableField;
